import styled from 'styled-components';
import { colors } from 'bench-style-constants';
import { rgba } from 'color-helpers';

export const StatementOCRHeaderLayout = styled.div`
  bottom: 0;
  left: 0;
  padding: 24px 32px 0;
  position: absolute;
  right: 0;
  top: 0;
`;

export const StatementOCRHeaderNavigationLayout = styled.div`
  border-bottom: 1px solid ${colors.silt};
  bottom: 0;
  display: flex;
  left: 0;
  padding: 0 8px;
  position: absolute;
  right: 0;
`;

interface StatementOCRTabProps {
  isActive: boolean;
}

export const StatementOCRTab = styled.button<StatementOCRTabProps>`
  background: transparent;
  border-radius: 0;
  border: 0 none;
  box-shadow: none;
  color: ${colors.dust};
  cursor: pointer;
  display: block;
  font-size: 16px;
  line-height: 16px;
  padding: 8px 24px;
  position: static;

  &:focus {
    background: ${rgba(colors.brook, 0.75)};
  }

  ${({ isActive }) =>
    isActive &&
    `
    box-shadow: 0 1px ${colors.water};
    color: ${colors.water};
  `};
`;
